<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.name }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CourierTabLinks />
                    <CourierUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @success="$router.push(`/couriers`)"
                        @deleted="$router.push(`/couriers`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import CourierTabLinks from '@/components/couriers/CourierTabLinks';
    import CourierUpsertForm from '@/components/couriers/CourierUpsertForm';

    export default {
        name: 'CourierEdit',

        components: {
            CourierTabLinks,
            CourierUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/couriers/${id}`)).data;
            },
        },
    };
</script>
